import types from "./types";

export const getOBLPListing = (payload) => ({
    type: types.GET_OBLP_LISTING, payload
})
export const getOBLPListingResp = (payload) => ({
    type: types.GET_OBLP_LISTING_RESP, payload
})
export const getOBLPListingClear = (payload) => ({
    type: types.GET_OBLP_LISTING_CLEAR
})

export const getNONOBLPListing = (payload) => ({
    type: types.GET_NON_OBLP_LISTING, payload
})
export const getNONOBLPListingResp = (payload) => ({
    type: types.GET_NON_OBLP_LISTING_RESP, payload
})
export const getNONOBLPListingClear = (payload) => ({
    type: types.GET_NON_OBLP_LISTING_CLEAR
})

export const getMyOBLPListing = (payload) => ({
    type: types.GET_MY_OBLP_LISTING, payload
})
export const getMyOBLPListingResp = (payload) => ({
    type: types.GET_MY_OBLP_LISTING_RESP, payload
})
export const getMyOBLPListingClear = (payload) => ({
    type: types.GET_MY_OBLP_LISTING_CLEAR
})

export const getNonMyOBLPListing = (payload) => ({
    type: types.GET_NON_MY_OBLP_LISTING, payload
})
export const getNonMyOBLPListingResp = (payload) => ({
    type: types.GET_NON_MY_OBLP_LISTING_RESP, payload
})
export const getNonMyOBLPListingClear = (payload) => ({
    type: types.GET_NON_MY_OBLP_LISTING_CLEAR
})

//Global Search LP
export const getGlobalSearchLP = (payload) => ({
    type: types.GLOBAL_SEARCH_LP,
    payload,
  });
  export const getGlobalSearchLPResponse = (payload) => ({
    type: types.GLOBAL_SEARCH_LP_RESPONSE,
    payload,
  });
  export const getGlobalSearchLPClear = () => ({
    type: types.GLOBAL_SEARCH_LP_CLEAR,
  });
//Global Search Course
export const getGlobalSearchCourse = (payload) => ({
    type: types.GLOBAL_SEARCH_COURSE,
    payload,
});
export const getGlobalSearchCourseResponse = (payload) => ({
    type: types.GLOBAL_SEARCH_COURSE_RESPONSE,
    payload,
});
export const getGlobalSearchCourseClear = () => ({
    type: types.GLOBAL_SEARCH_COURSE_CLEAR,
});

  //LP Included with paid subscription
export const getLPsWithSubscription = (payload) => ({
    type: types.LP_INCLUDED_WITH_SUBSCRIPTION,
    payload,
  });
  export const getLPsWithSubscriptionResponse = (payload) => ({
    type: types.LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE,
    payload,
  });
  export const getLPsWithSubscriptionClear = () => ({
    type: types.LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR,
  });